import axios from "axios";

const axiosRequest = ({ method, url, data, headers, params }) => {
  const token = localStorage.getItem("_uid");
  const defaultHeaders = { Authorization: `Token ${token}` };
  const config = {
    method,
    url,
    data,
    params,
    headers: headers ? headers : defaultHeaders,
  };

  return new Promise((resolve, reject) => {
    axios(config).then(resolve).catch(reject);
  });
};

export default axiosRequest;
